import { GET_CUSTOM_FIELDS_REQUEST, SET_CUSTOM_FIELDS } from './custom-field.action';

const initialState = {
  customFields: [],
  loading: false,
  error: undefined
};

const customFieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOM_FIELDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined
      };
    case SET_CUSTOM_FIELDS:
      return {
        ...state,
        loading: false,
        customFields: action.data || [],
        error: action.error || undefined
      };
    default:
      return state;
  }
};

export default customFieldReducer;
